module.exports = __webpack_public_path__ + "img/nt1-12-75-1.prt.3c78674b.jpg";